import React from 'react';
import { Box } from '@mui/material';
import TranscriptSegment from './TranscriptSegment';

import type { CombinedTranscript } from '@/types/transcript';

interface MultiChannelTranscriptProps {
    transcript: CombinedTranscript[];
}

/**
 * Component that renders a multi-channel transcript in a dialogue format.
 *
 * @param {MultiChannelTranscriptProps} props
 * @returns {JSX.Element}
 */
const MultiChannelTranscript: React.FC<MultiChannelTranscriptProps> = ({ transcript }) => {
    return (
        <Box sx={{ overflowY: 'auto', height: '100%', px: 2, py: 1.5 }}>
            {transcript.map((segment, segmentIndex) => (
                <TranscriptSegment
                    key={segmentIndex}
                    text={segment.text}
                    start={segment.start}
                    speaker={segment.speaker}
                    backgroundColor={segment.speaker === 'agent' ? 'secondary.light' : 'transparent'}
                />
            ))}
        </Box>
    );
};

export default MultiChannelTranscript;
